import { FunctionComponent } from "react";
import { Button } from "../../../components/Button";
import IconButton from "../../../components/iconButton/IconButton";
import { formatDate, formatTime } from "../../../../services/dateService";
import { PriorityStreamPreview } from "./types";

interface Props {
    streams: PriorityStreamPreview[];
    onEdit: (s: PriorityStreamPreview) => void;
    onRemove: (s: PriorityStreamPreview) => void;
    onProcess: () => void;
}

const PriorityStreamsTable: FunctionComponent<Props> = ({ streams, onEdit, onRemove, onProcess }) => (
    <>
        <h4>Priority Streams</h4>
        <table className="table">
            <thead>
                <tr>
                    <td>Name</td>
                    <td>Description</td>
                    <td>Start</td>
                    <td>End</td>
                    <td>Source</td>
                    <td></td>
                </tr>
            </thead>
            <tbody>
                {streams.map(it => (
                    <tr key={it.id}>
                        <td>{it.programName}</td>
                        <td title={it.fullDescription || undefined}>{it.shortDescription}</td>
                        <td>{formatDate(it.startTime)} {formatTime(it.startTime)}</td>
                        <td>{formatDate(it.endTime)} {formatTime(it.endTime)}</td>
                        <td>{it.tvChannelName}</td>
                        <td>
                            <IconButton tooltipText="Edit" type="edit" onClick={() => onEdit(it)} />
                            <IconButton tooltipText="Remove" type="delete" onClick={() => onRemove(it)} />
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
        <div className="d-flex justify-content-end mb-20">
            <Button color="green" label="Process" onClick={onProcess} />
        </div>
    </>
);

export default PriorityStreamsTable;
